import { useState } from "react";
import PagePadding from "../layouts/PagePadding";
import heroOne from "../assets/heroOne.webp";
import logo from "../assets/thrifit-logo-white.png";
import Rolling from "../components/loading/Rolling";
import Filter from "../layouts/Filter";
import Favourites from "../components/explore/Favourites";
import rollingWhite from "../assets/rolling-white.svg";
import Products from "../components/explore/Products";
import Pagination from "../components/pagination/Pagination";
import SortBy from "../components/sort-by/SortBy";
import MobileFilter from "../components/mobile/Filter";
import Backdrop from "../components/mobile/Backdrop";
import AddressInput from "../components/form-input/address-input/AddressInput";
import useAuth from "../hooks/useAuth";

const Explore = () => {
  const {
    explore: { loading, categories, brands, sizes, gender, products },
    cart,
    favourite,
  } = useAuth();

  const [filter, setFilter] = useState([]);

  const [mobileFilter, setMobileFilter] = useState(false);

  const handleCategoryFilter = (e) => {
    if (e.target.checked)
      setFilter(
        products.filter(
          (product) => product.product_category.code === e.target.value
        )
      );
  };

  const handleGenderFilter = (e) => {
    if (e.target.checked)
      setFilter(
        products.filter(
          (product) => product.product_gender.code === e.target.value
        )
      );
  };

  const handleSizeFilter = (e) => {
    if (e.target.checked)
      setFilter(
        products.filter(
          (product) => product.product_sizes[0].code === e.target.value
        )
      );
  };

  const [value, setValue] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(6);
  const lastItem = currentPage * itemPerPage;
  const firstItem = lastItem - itemPerPage;
  const currentItemOnPage =
    filter.length > 0
      ? filter?.slice(firstItem, lastItem)
      : products?.slice(firstItem, lastItem);

  return (
    <div className={`bg-slate-100 min-h-screen pb-10 md:pb-48 relative `}>
      <PagePadding>
        <p className="pt-2 text-sm text-label">
          Home /<span className="text-black"> Explore</span>
        </p>

        <div
          className="h-hero flex items-center p-5 bg-cover bg-center mt-4"
          style={{ backgroundImage: `url("${heroOne}")` }}
        >
          <div>
            <img src={logo} alt="thrifit logo" />
            <p className="font-bold text-2xl text-white pt-5">
              Shop products and quality thrift female <br />
              wears from around the globe
            </p>
            <p className="text-sm md:text-base font-normal text-white pt-5">
              Free delivery on products above $500
            </p>
          </div>
        </div>

        {loading ? (
          <Rolling src={rollingWhite} />
        ) : (
          <div className={``}>
            <Favourites favourite={favourite} />

            <div className="flex flex-col lg:flex-row gap-0 lg:gap-3">
              <section className="hidden lg:block">
                <div>
                  <Filter header="Browse Categories">
                    {categories?.map(({ name, code }) => (
                      <div key={code} className="flex gap-3 items-center mt-2">
                        <AddressInput
                          value={code}
                          onchange={handleCategoryFilter}
                          name="size"
                        />
                        <div className="font-normal text-sm">{name}</div>
                      </div>
                      // <button
                      //   key={code}
                      //   className="block border-none outline-none bg-none mt-3"
                      // >
                      //   {name}
                      // </button>
                    ))}
                  </Filter>

                  <Filter header="Brand">
                    <div className="relative mt-5">
                      <input
                        type="text"
                        className="w-9/10 h-8 border-lightGrey border rounded-xl pl-8 outline-none"
                        placeholder="Search by brand name"
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="absolute top-2 left-2 bi bi-search"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                      </svg>
                    </div>
                    <div className="mt-3">
                      {brands?.map(({ name, code }) => (
                        <div
                          key={code}
                          className="flex gap-3 items-center mt-2"
                        >
                          <AddressInput value={code} name="brand" />
                          <div className="font-normal text-sm">{name}</div>
                        </div>
                      ))}
                    </div>
                  </Filter>

                  {/* price range here */}

                  <Filter header="Size">
                    <div className="mt-3">
                      {sizes?.map(({ name, code }) => (
                        <div
                          key={code}
                          className="flex gap-3 items-center mt-2"
                        >
                          <AddressInput
                            value={code}
                            onchange={handleSizeFilter}
                            name="size"
                          />
                          <div className="font-normal text-sm">{name}</div>
                        </div>
                      ))}
                    </div>
                  </Filter>

                  <Filter header="Gender">
                    <div className="mt-3">
                      {gender?.map(({ name, code }) => (
                        <div
                          key={code}
                          className="flex gap-3 items-center mt-2"
                        >
                          <AddressInput
                            value={code}
                            onchange={handleGenderFilter}
                            name="gender"
                          />
                          <div className="font-normal text-sm">{name}</div>
                        </div>
                      ))}
                    </div>
                  </Filter>
                </div>

                <div></div>
              </section>

              <div
                className="block lg:hidden mt-5"
                onClick={() => setMobileFilter(true)}
              >
                <div className="flex justify-end items-center ">
                  <button className="h-11 w-28 flex gap-3 items-center justify-center text-logoRed font-bold bg-white border border-logoRed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-filter font-bold"
                      viewBox="0 0 16 16"
                    >
                      <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />
                    </svg>
                    <div>Filter</div>
                  </button>
                </div>
              </div>

              <section className="bg-white w-full  mt-3">
                <div className="pt-5 pr-[10px] pl-[10px] md:pr-[15.5px] md:pl-[15.5px] pb-3 flex justify-between ">
                  <p className="font-bold text-sm">
                    All products{" "}
                    <span className="text-label">{`(Showing ${
                      products?.length || "0"
                    } products)`}</span>
                  </p>
                  <SortBy
                    margin="mt-0"
                    setFilter={setFilter}
                    product={products}
                  />
                </div>

                <div className="pr-[10px] pl-[10px] md:pr-[15.5px] md:pl-[15.5px] flex gap-[13px] md:gap-[15.5px] flex-wrap">
                  {currentItemOnPage?.map((product, index) => (
                    <Products
                      data={product}
                      index={index}
                      key={product.product_image.front_view}
                      cart={cart}
                      favourite={favourite}
                    />
                  ))}
                </div>

                <div className="pb-5">
                  <Pagination
                    itemPerPage={itemPerPage}
                    totalItem={products?.length}
                    value={value}
                    setValue={setValue}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </section>
            </div>
          </div>
        )}
      </PagePadding>
      {mobileFilter ? (
        <>
          <MobileFilter
            category={categories}
            brand={brands}
            size={sizes}
            gender={gender}
            genderFilter={handleGenderFilter}
            sizeFilter={handleSizeFilter}
            close={setMobileFilter}
          />
          <Backdrop sidebar={mobileFilter} />
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default Explore;
